/*
 * Lo que la PERSONA ha escrito en la ficha que tiene abierta, ANOTADO cuando lo escribe.
 *
 * LA FAMILIA QUE CIERRA ESTO: «edicion-adivinada-por-el-valor-final» (#387, revision del PR #1793)
 *
 * El editor de herramientas de tarifas tiene campos que solo se guardan si la persona los ha
 * escrito, porque escribirlos sin que nadie los toque estropea un dato del servidor: la `formula`
 * que vino, la raiz que el editor no sabe pintar y aparto, el `kmmin` propio de la herramienta.
 * Hasta ahora cada uno de esos sitios ADIVINABA la respuesta mirando el valor que quedaba en
 * pantalla al guardar -comparandolo con el relleno inicial, o midiendo si la lista tenia algo-, y
 * esa pregunta no se puede contestar asi: el editor rellena las cajas con un neutro ('0', una lista
 * vacia) para poder pintarlas, de modo que la persona que escribe EXACTAMENTE ese neutro para
 * reparar un dato invalido es indistinguible de la que no toco nada. Consecuencia medida: una
 * herramienta que llega con `formula: 7` o `secciones: 7` no se puede reparar desde la pantalla
 * -se le devuelve el 7 una y otra vez-, y el `kmmin` propio no se puede quitar porque vaciar la
 * caja se lee como «no la ha tocado».
 *
 * Tres sitios con tres comparaciones distintas son tres oportunidades de equivocarse, asi que la
 * pregunta se contesta en UN sitio y no se adivina: se anota en el momento en que la persona
 * escribe, y al guardar solo se pregunta. Es la misma decision de diseño que `formaDeLaRaiz` en
 * `TarifaHerramienta.js` -quien decide, decide una vez y los demas preguntan-.
 *
 * LA LISTA DE `CAMPOS` ES LA CHECKLIST. Si se añade al editor otro campo que solo deba guardarse
 * cuando alguien lo escribe, va aqui y su manejador llama a `anota`; preguntar por un campo que no
 * esta revienta a proposito, porque las dos salidas silenciosas son malas -contestar `true` guarda
 * encima de un dato del servidor y contestar `false` ignora lo que la persona acaba de escribir-.
 */

const CAMPOS = ['formula', 'secciones', 'alertas', 'kmmin'];

export default function edicionDeLaFicha() {
    let escrito = {};

    function elCampo(campo) {
        if (CAMPOS.indexOf(campo) < 0) {
            throw new Error('edicionDeLaFicha: `' + campo + '` no es un campo que se decida por edicion');
        }
        return campo;
    }

    return {
        /** Los campos que se deciden asi, para quien los recorre: el editor y su banco. */
        CAMPOS: CAMPOS.slice(),
        /**
         * Se abre una ficha: lo que anotara de aqui en adelante es de ESTA, y lo anotado en la
         * anterior no cuenta. Se llama tambien al duplicar, que abre una ficha nueva con el
         * contenido de otra.
         */
        fichaNueva: function () {
            escrito = {};
        },
        /** La persona acaba de escribir en ese campo. No importa que haya escrito, ni si coincide. */
        anota: function (campo) {
            escrito[elCampo(campo)] = true;
        },
        /** Si lo que hay en ese campo lo ha puesto la persona en esta ficha. */
        laHaEscrito: function (campo) {
            return escrito[elCampo(campo)] === true;
        }
    };
}
